export default "__VITE_ASSET__edu$kl1t__"